import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axis from '../Axis';

var XAxis =
/*#__PURE__*/
function (_Component) {
  _inherits(XAxis, _Component);

  function XAxis() {
    _classCallCheck(this, XAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
  }

  _createClass(XAxis, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getChart = _this$props.getChart,
          id = _this$props.id,
          rest = _objectWithoutProperties(_this$props, ["getChart", "id"]);

      var chart = getChart();
      var isStockChart = chart.type === 'stockChart';
      var type = isStockChart ? 'datetime' : 'linear';
      var axisId = isStockChart ? 'xAxis' : id;
      return React.createElement(Axis, _extends({
        type: type
      }, rest, {
        id: axisId,
        isX: true
      }));
    }
  }]);

  return XAxis;
}(Component);

export default XAxis;